import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { CustomEase } from "gsap/CustomEase";
import Swiper from 'swiper/bundle';


/*-------------------------------------
 スクロール時の処理
--------------------------------------*/
let startPos = 0;
let winScrollTop = 0;
let threshold = window.innerHeight * 0.5;
const topSliderEl = document.getElementById('topSlider');

window.addEventListener('scroll', () => {
  winScrollTop = window.scrollY;

  if (topSliderEl) {
    const topSliderHeight = topSliderEl.offsetHeight;
    if (winScrollTop >= topSliderHeight) {
      document.body.classList.add('is-scroll-toppage');
    } else {
      document.body.classList.remove('is-scroll-toppage');
    }
  } else {
    document.body.classList.remove('is-scroll-toppage');
  }

  if (winScrollTop !== 0) {
    document.body.classList.add('is-scroll');
  } else {
    document.body.classList.remove('is-scroll');
  }

  if (winScrollTop >= startPos) {
    if (winScrollTop >= threshold) {
      document.body.classList.add('is-down');
    }
  } else {
    document.body.classList.remove('is-down');
  }
  startPos = winScrollTop;
});
window.addEventListener('resize', () => {
  threshold = window.innerHeight;
});

/*-------------------------------------
 GSAP ScrollTrigger
--------------------------------------*/
gsap.registerPlugin(ScrollTrigger);

function createScrollTrigger(selector, start, className, markers = false, pin = false) {
  const elements = document.querySelectorAll(selector);
  elements.forEach((el, index) => {
    ScrollTrigger.create({
      trigger: el,
      id: index + 1,
      start: start,
      toggleClass: { targets: el, className: className },
      once: true,
      markers: markers,
			pin: pin,
    });
  });
}

/*-------------------------------------
 メニュー開閉・トグル関連
--------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  createScrollTrigger('.fadeUp','top 75%','is-active');
  document.body.classList.add('is-ready');

  // リサイズ対応
  function handleResize() {
    if (window.innerWidth >= 768) {
      document.body.classList.remove('fixed');
      document.body.style.top = '0';
    }
  }
  window.addEventListener('load', handleResize);
  window.addEventListener('resize', handleResize);
});

